import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'client/js/store/store.js'
import HomePage from "client/components/HomePage.vue"
import PageNotFound from "client/components/PageNotFound.vue"
import SelectCoursePage from 'client/components/SelectCoursePage.vue'
import SetPreferencePage from 'client/components/SetPreferencePage.vue'
import SelectUnitsPage from 'client/components/SelectUnitsPage.vue'
import CreatePlanPage from 'client/components/CreatePlanPage.vue'
import SavedCoursePlanPage from 'client/components/SavedCoursePlanPage.vue'

const DEBUG = false

Vue.use(VueRouter)

const routes = [
   {
      name: "home-page",
      path: '/',
      component: HomePage, // require('client/components/application/EGVueHome.vue').default,
      meta: { requiresAuth: false }
   },
   {
      name: "select-course",
      path: '/select-course',
      component: SelectCoursePage,
      meta: { requiresAuth: false }
   },
   {
      name: "set-preference",
      path: '/set-preference',
      component: SetPreferencePage,
      meta: { requiresAuth: false }
   },
   {
      name: "select-units",
      path: '/select-units',
      component: SelectUnitsPage,
      meta: { requiresAuth: false }
   },
   {
      name: "create-plan",
      path: '/create-plan',
      component: CreatePlanPage,
      meta: { requiresAuth: false }
   },
   {
      name: "saved-plan",
      path: '/saved-plan',
      component: SavedCoursePlanPage,
      meta: { requiresAuth: false }
   },
   {
      name: "review-preferences",
      path: '/review-preferences',
      component: SetPreferencePage,
      meta: { requiresAuth: false }
   },
   {
      name: "review-units",
      path: '/review-units',
      component: SelectUnitsPage,
      meta: { requiresAuth: false }
   },
   {
      name: "create-new-plan",
      path: '/create-new-plan',
      component: CreatePlanPage,
      meta: { requiresAuth: false }
   },
   {
      name: "not-found",
      path: '*', //if no path is given - redirect to the main-content route with the path paramater as the store/step module defined default path
      component: PageNotFound
   }
];

const Router = function (baseUrl, store) {
   const router = new VueRouter({
      mode: "history",
      base: baseUrl,
      linkActiveClass: "active",
      routes
   })

   /* Authentication Check for routes */
   // TODO: Have this pre-populate/update the Login/Logout URLs in store, so Components get the right one for links.
   router.beforeEach(async (to, from, next) => {
      await store.restored // wait for store to be restored

      if (DEBUG) console.log('Changing Route...', from, to)

      // Authentication
      let thisUrl = BaseURL + to.fullPath
      store.commit('global/setThisUrl', thisUrl)
      // Check/update existing authenticated user
      // console.log('Fetch Auth User')
      await store.dispatch('global/fetchAuthUser')

      if (to.matched.some(record => record.meta.requiresAuth)) {
         // console.log('Is Authenticated?')
         if (store.getters['global/isAuthenticated']) {
            next()
            return
         }
         // Not Authenticated - redirect to Server Login URL
         window.location.assign(store.getters['global/loginUrl'])
      } else {
         // Page Routing
         if (to.name === 'home-page') {
            next()
            if (document.getElementById('wrapperOuter')) {
               document.getElementById('wrapperOuter').style.scrollBehavior = 'auto'
               document.getElementById('wrapperOuter').scrollTop = 0
               document.getElementById('wrapperOuter').removeAttribute('style')
            }
            store.dispatch('userJourney/reset')
            return
         }
         const navigatedStep = store.getters['userJourney/getStepByName'](to.name);
         if (navigatedStep) {
            if (navigatedStep.enabled) {

               //get step index, and journey index, and assign the step name and index.
               var stepIndex = navigatedStep.index;
               var stepJourney = navigatedStep.journey;

               //if we are swapping journey, we will need to reset the state.
               if (stepJourney != store.getters['userJourney/getCurrentJourney'])
               {
                  store.dispatch('userJourney/reset')
               }

               store.commit('userJourney/setCurrentStepIndex', stepIndex)
               store.commit('userJourney/setCurrentJourney', stepJourney)
               store.commit('userJourney/setStepInvalidate')
               next()
               if (document.getElementById('wrapperOuter')) {
                  document.getElementById('wrapperOuter').style.scrollBehavior = 'auto'
                  document.getElementById('wrapperOuter').scrollTop = 0
                  document.getElementById('wrapperOuter').removeAttribute('style')
               }
               return
            } else {
               console.log('Steps out of sequence - redirecting to last valid step')
               const currentValidStep = store.getters['userJourney/getCurrentStep']
               store.commit('userJourney/setStepInvalidate')
               next("/" + currentValidStep.name)
               return
            }
         }
         else {
            console.log('Unknown step - redirecting to homepage')
            store.dispatch('userJourney/reset')
            next('/')
            return
         }
      }
      next()
   })
   return router
}
module.exports = Router
